export default __webpack_public_path__ + "form_summary_vector.svg";